import { useEffect } from 'react';
import { removeToken } from '@/utils/cookies';

function Logout() {
  useEffect(() => {
    const language = localStorage.getItem('nptlabs_language');

    // Clear all localStorage
    localStorage.clear();
    if (language) {
      localStorage.setItem('nptlabs_language', language);
    }
    
    // Clear token from cookies
    removeToken();
    
    // Clear all cookies (optional, but thorough)
    document.cookie.split(';').forEach((c) => {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
    
    window.location.href = '/authorization';
  }, []);

  return null;
}

export default Logout;
